import { render } from "./resetPassword.vue?vue&type=template&id=f3af7834&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=f3af7834&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f3af7834"

export default script